export default {
  width: 20,
  height: 20,
  fill: 'var(--wild-iris)',
  strokeWidth: 1,
};
